import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { Box, Button, Chip, Paper, Tab, Tabs, Typography } from '@mui/material'
import { useState } from 'react'
import { usePlanificaciones } from '../providers/PlanificacionesProvider'
import DatosPlanificacion from './form/DatosPlanificacion'
import FormView from './form/FormView'
import KpisOptimizacion from './kpis/KpisOptimizacion'
import GanttPlanificacion from './shared/GanttPlanificacion'

export default function DetailView() {
  const { selectedPlanificacion, formMode, goToDashboard, planificacionStatus } =
    usePlanificaciones()

  const [activeTabKey, setActiveTabKey] = useState('form')
  const [kpisData, setKpisData] = useState({
    kpis: null,
    produccionDiaria: null,
    produccionDiariaPorArticulo: null,
  })

  const isEdit = formMode === 'edit'
  const hasGantt = isEdit && planificacionStatus === 'Z'

  const tabs = [
    { label: 'Formulario', key: 'form' },
    ...(hasGantt ? [{ label: 'Diagrama de Gantt', key: 'gantt' }] : []),
    ...(hasGantt ? [{ label: 'KPIs de Optimización', key: 'kpis' }] : []),
    ...(isEdit ? [{ label: 'Datos de Planificación', key: 'datos' }] : []),
  ]

  // Si el tab activo desaparece (seguridad), volver al primero
  const tabIndex = tabs.findIndex((t) => t.key === activeTabKey)
  const safeTabIndex = tabIndex === -1 ? 0 : tabIndex

  const handleTabChange = (_, newIndex) => setActiveTabKey(tabs[newIndex].key)

  const handleKpisLoaded = (kpis, produccionDiaria, produccionDiariaPorArticulo) => {
    setKpisData({ kpis, produccionDiaria, produccionDiariaPorArticulo })
  }

  const title = isEdit ? 'Editar Planificación' : 'Nueva Planificación'
  const subtitle = isEdit
    ? 'Modifica los datos o revisa los resultados de optimización'
    : 'Completa los datos para crear una nueva planificación de producción'

  const activeKey = tabs[safeTabIndex]?.key

  return (
    <Box sx={{ p: 3 }}>
      {/* Header unificado */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography variant="h4" sx={{ mb: 1, fontWeight: 'bold' }}>
              {title}
              {isEdit && (
                <Chip
                  label={`ID: ${selectedPlanificacion?.id}`}
                  size="small"
                  color="primary"
                  sx={{ ml: 2, fontWeight: 'bold' }}
                />
              )}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          </Box>
          <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={goToDashboard}>
            Volver al Dashboard
          </Button>
        </Box>
      </Paper>

      {/* Tabs - solo si hay más de 1 */}
      {tabs.length > 1 && (
        <Paper sx={{ mb: 3 }}>
          <Tabs value={safeTabIndex} onChange={handleTabChange}>
            {tabs.map((tab) => (
              <Tab key={tab.key} label={tab.label} />
            ))}
          </Tabs>
        </Paper>
      )}

      {/* Contenido */}
      {activeKey === 'form' && <FormView />}
      {activeKey === 'gantt' && (
        <GanttPlanificacion
          idPlanificacion={selectedPlanificacion?.id}
          onKpisLoaded={handleKpisLoaded}
        />
      )}
      {activeKey === 'kpis' && (
        <KpisOptimizacion
          kpis={kpisData.kpis}
          produccionDiaria={kpisData.produccionDiaria}
          produccionDiariaPorArticulo={kpisData.produccionDiariaPorArticulo}
          fechaInicio={selectedPlanificacion?.fecha_inicio}
        />
      )}
      {activeKey === 'datos' && <DatosPlanificacion idPlanificacion={selectedPlanificacion?.id} />}
    </Box>
  )
}
